import Amplify from "aws-amplify"

const configureAmplify = (): void => {
  Amplify.Logger.LOG_LEVEL = process.env.AMPLIFY_LOGGER_LOG_LEVEL

  Amplify.configure({
    Auth: {
      identityPoolId: process.env.AMPLIFY_AUTH_IDENTITY_POOL_ID,
      region: process.env.AMPLIFY_AUTH_REGION,
      userPoolId: process.env.AMPLIFY_AUTH_USER_POOL_ID,
      userPoolWebClientId: process.env.AMPLIFY_AUTH_USER_POOL_WEB_CLIENT_ID,
    },
    Storage: {
      AWSS3: {
        bucket: process.env.AMPLIFY_STORAGE_S3_BUCKET,
        region: process.env.AMPLIFY_STORAGE_AUTH_REGION,
      },
    },
  })
}

export default configureAmplify
